"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getPostTitle;
function getPostTitle({ title, publishDate, author, mappers, inHero, packages, forms, }) {
    let postTitle;
    if (inHero && title) {
        const [firstChild] = title.root?.children ?? [];
        if (firstChild) {
            firstChild.tag = 'h1';
            firstChild.type = 'heading';
            postTitle = mappers.mapRichText({
                richText: title,
                mappers,
                inHero,
                packages,
                forms,
            });
        }
    }
    return { postTitle };
}
